import { createApp } from "vue";
import { createWebHashHistory, createRouter } from 'vue-router'
import { createPinia } from 'pinia'
import basic_button from "./components/basic_button.vue";
import confirm_button from "./components/confirm_button.vue";
import money_input from "./components/money_input.vue";
import App from "./App.vue";
import error_zone from "./module/error_handler/components/error_zone.vue";
import alert from "./components/alert.vue";
import Home from "./pages/Home.vue";
import Reports from "./pages/Reports.vue";
import Settings from "./pages/Settings.vue";
import Login from "./pages/Login.vue";
import RegisterUser from "./pages/RegisterUser.vue";
import { init_auth, is_authed } from "./module/auth/module";
import Users from "./pages/Users.vue";
import vSelect from 'vue-select'

const pinia = createPinia()

const routes = [
  { path: '/', component: Home, name: "Home" },
  { path: '/reports', component: Reports, name: "Reports" },
  { path: '/settings', component: Settings, name: "Settings" },
  { path: '/users', component: Users, name: "Users" },
  { path: '/login', component: Login, name: 'Login' },
  { path: '/register/:new_user_token', component: RegisterUser, name: 'RegisterUser' },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach(async (to, from) => {
    if (!is_authed()
      && (
        to.name === 'Home'
        || to.name === 'Users'
      )
    ) {
        // redirect the user to the login page
        return { name: 'Login' }
    }
})


init_auth(router)




const vue_app = createApp(App)
    .use(pinia)
    .use(router)
    .component('basic_button', basic_button)
    .component('confirm_button', confirm_button)
    .component('money_input', money_input)
    .component('error_zone', error_zone)
    .component('v-select', vSelect)
    .component('alert', alert)

// The important part for HMR
if (import.meta.hot) {
  import.meta.hot.on('bun:invalidate', () => {
    vue_app.unmount();
  })
  import.meta.hot.accept()
}

vue_app.mount('#app')